export const vert = /*glsl*/ `
precision mediump float;

uniform mat4 projectionMatrix;
uniform mat4 modelViewMatrix;
uniform mat4 modelMatrix;
uniform float uTime;
uniform float uMeshAnimation;
uniform vec3 uMeshDirection;
uniform float uMeshSpeed;

attribute vec3 position;
attribute vec2 uv;

varying vec2 vUv;
varying float vTime;
varying vec3 vPosition;

void main(){
  vUv = uv;
  vTime = uTime;
  float t = uTime * .0001 * uMeshSpeed;

  vec4 pos = modelViewMatrix * vec4(position, 1.);
  #ifdef USE_UV_FOR_DISPLACEMENT
    pos.xyz += vec3(sin(uv.y * 4. + t), cos(uv.x * 3. + t) * 10., sin(uv.y * 2. + t)) * .2 * uMeshAnimation * uMeshDirection;
  #else
    pos.xyz += vec3(sin(position.y * 4. + t), cos(position.x * 3. + t) * 10., sin(position.z * 2. + t)) * .2 * uMeshAnimation * uMeshDirection;
  #endif

  gl_Position = projectionMatrix * pos;
  vPosition = vec3(gl_Position);
}`;
